import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '@apps/app.constants';
import { BaseListApiService } from '@common/api/base-list-api.service';
import { ResultApi } from '@common/api/result-api';
import { VbrRatesApi } from '../../models/vbr-rates-api';

@Injectable({
    providedIn: 'root'
})
export class VbrCapacityListApiService extends BaseListApiService<VbrRatesApi>
{
    private endPoint = '/ratespervm';

    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlHist;
        this.resourceUrl = '/hist/veeam/';
    }

    getRatesPerVm (range: string): Observable<ResultApi<VbrRatesApi>>
    {
        return this.getAll(`${this.resourceUrl}${this.endPoint}?${range}`);
    }
}
